import captureException from 'src/common/utils/captureException';
import apiFetch from 'src/common/utils/apiFetch';
import { trackEvent } from 'src/common/3rdParty/tracking';
import { Trip } from 'src/common/types/api/v4/trips';
import { InquiryData } from '../types';

const bookInstantly = async (
  inquiryData: Pick<InquiryData,
  | 'preferred_date1'
  | 'pickup_time'
  | 'trip_length'
  | 'adults'
  | 'captain_required'
  | 'comment'>,
  listingId: string,
): Promise<Trip | null> => {
  try {
    const url = '/api/v4/trips/book-instantly/';
    const response = await apiFetch<Trip>(url, {
      method: 'POST',
      body: JSON.stringify({
        ...inquiryData,
        boat_hash: listingId,
      }),
    });

    if (response?.pk) {
      // Send conversion event to Google AdWords when on Production
      // where we have defined the conversion ID in the environment variables.
      if (process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_INQUIRY) {
        trackEvent('conversion', {
          send_to: process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_INQUIRY,
        });
      }
      return response;
    }
  } catch (error) {
    captureException(error);
  }
  return null;
};

export default bookInstantly;
